/* eslint-disable */
// Global packages
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import queryString from 'query-string';
import PropTypes from 'prop-types';

// Selectors
import {
    isLoggedIn as isLoggedInSelector,
} from 'ggApp/modules/auth/selectors';

import {
    storeActive as activeStoreSelector,
    isPartnerStore as isActiveStorePartnerSelector,
    mainRouteWithStoreAndLanguage as mainRouteWithStoreAndLanguageSelector,
} from 'ggApp/modules/store/selectors';

import {
    orderActive as activeOrderSelector,
} from 'ggApp/modules/order/selectors';

// Utils
import { partnerReturnUrl } from 'ggApp/modules/store/selectors';

/**
 * Build back-to-home link to leave the cart page
 * @description This component has a render prop to return an object
 * with backToHomeLink field.
 * @class CartBackToHomeLinkBuilder
 * @extends {PureComponent}
 */
@connect(
    createStructuredSelector({
        isLoggedIn: isLoggedInSelector,
        order: activeOrderSelector,
        storeActive: activeStoreSelector,
        isPartnerStore: isActiveStorePartnerSelector,
        mainRouteWithStoreAndLanguage: mainRouteWithStoreAndLanguageSelector,
    }),
)
class CartBackToHomeLinkBuilder extends PureComponent {
    static propTypes = {
        render: PropTypes.func.isRequired,
        withExpandedProductDiscoveryDrawer: PropTypes.bool,
    };

    buildPartnerLink = () => {
        const {
            order: { items },
            storeActive: { code },
        } = this.props;

        const { variant = {} } = (items && items[0]) || {};
        const variantId = variant.id;

        if (variantId && code) {
            return partnerReturnUrl(code, variantId);
        }
    };

    buildLink = () => {
        const {
            isLoggedIn,
            isPartnerStore,
            mainRouteWithStoreAndLanguage: rootRoute,
        } = this.props;

        if (isPartnerStore) {
            return this.buildPartnerLink();
        }

        if (!isLoggedIn) {
            return `${rootRoute}/?${queryString.stringify({
                'with-expanded-product-discovery-drawer': true,
            })}`;
        }

        return `${rootRoute}/`;
    };

    render() {
        const { render } = this.props;

        return render({ backToHomeLink: this.buildLink() });
    }
}

export { CartBackToHomeLinkBuilder };
